var blockquote_default = {
  "fontElementMap": "_5svCU",
  "quoteContainer": "qbW3A",
  "quote": "TN2i6"
};
export {
  blockquote_default as default
};
//# sourceMappingURL=blockquote-scss.js.map
